<div class="main">
    <button mat-fab class="sidenav-icon-button" color="primary" routerLink={{routerLink}} aria-label="Example">
        <mat-icon>{{iconId}}</mat-icon>
    </button>
    <b class="label">{{ label }}</b>
</div>
